import * as angular from 'angular';

export class AuthFactory {
    private apiRoot: string = '/api/v1/auth';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    readMe() {
        return this.$http.get(
            `${this.apiRoot}/user/`
        );
    }

    tosAccept(value: any) {
        return this.$http.put(
            `${this.apiRoot}/user/accept_tos/`,
            value
        );
    }

    authLoginMulti(value: any) {
        return this.$http.post(
            `${this.apiRoot}/login/multi/`,
            value
        );
    }

    authLogout() {
        return this.$http.post(
            `${this.apiRoot}/logout/`
        );
    }

    authPasswordReset(value: any) {
        return this.$http.post(
            `${this.apiRoot}/password/reset/`,
            value
        );
    }

    authPasswordResetConfirm(value: any) {
        return this.$http.post(
            `${this.apiRoot}/password/reset/confirm/`,
            value
        );
    }

    getToken(userId: string) {
        return this.$http.get(
            `${this.apiRoot}/users/${userId}/token/`
        );
    }
}

angular
    .module('app')
    .service('AuthFactory', AuthFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/auth.factory.ts